/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileRefDTO
 */
export interface FileRefDTO {
    /**
     * 
     * @type {string}
     * @memberof FileRefDTO
     */
    mimeType?: string;
    /**
     * 
     * @type {string}
     * @memberof FileRefDTO
     */
    path?: string;
    /**
     * 
     * @type {number}
     * @memberof FileRefDTO
     */
    sizeBytes?: number;
}

/**
 * Check if a given object implements the FileRefDTO interface.
 */
export function instanceOfFileRefDTO(value: object): value is FileRefDTO {
    return true;
}

export function FileRefDTOFromJSON(json: any): FileRefDTO {
    return FileRefDTOFromJSONTyped(json, false);
}

export function FileRefDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileRefDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'mimeType': json['mimeType'] == null ? undefined : json['mimeType'],
        'path': json['path'] == null ? undefined : json['path'],
        'sizeBytes': json['sizeBytes'] == null ? undefined : json['sizeBytes'],
    };
}

export function FileRefDTOToJSON(value?: FileRefDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'mimeType': value['mimeType'],
        'path': value['path'],
        'sizeBytes': value['sizeBytes'],
    };
}

